<template>
  <date-picker
    v-model="dateSelected"
    prefix-class="xmx"
    :type="dateType"
    :lang="{
      formatLocale: {
        firstDayOfWeek: 1,
        months: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
        monthsShort: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        weekdaysMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'],
      },
      monthBeforeYear: true,
    }"
    :range="range"
    :format="formatType"
    :show-second="false"
    :disabled-date="disabledDate"
    title-format="DD/MM/YYYY"
    time-title-format="DD/MM/YYYY"
    :confirm="true"
    confirm-text="CONFIRMAR"
    :show-time-panel="showTimePanel"
    :placeholder="placeholder"
    class="ap-datepicker"
  >
    <template #footer>
      <button
        class="md-button btn btn-nonenary"
        @click="toggleTimePanel"
      >
        {{ showTimePanel ? 'Selecionar data' : 'Selecionar hora e minuto' }}
      </button>
    </template>
  </date-picker>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ApDatepicker',
  props: {
    date: {
      type: [Array, Date, String],
      default: null,
    },
    hasTime: {
      type: Boolean,
      default: false,
    },
    range: {
      type: Boolean,
      default: true,
    },
    disabledDate: {
      type: Function,
      default: () => date => date >= new Date(),
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showTimePanel: false,
      dateType: 'date',
      formatType: 'DD/MM/YYYY',
    }
  },
  computed: {
    ...mapGetters(['profile']),
    dateSelected: {
      get() {
        if (this.range) {
          return Array.isArray(this.date) ? this.date : this.date ? [this.date] : []
        } else {
          if (Array.isArray(this.date)) {
            return this.date.length > 0 ? this.date[0] : null
          }
          return this.date || null
        }
      },
      set(val) {
        if (this.range) {
          this.$emit('update:date', Array.isArray(val) ? val : val ? [val] : [])
        } else {
          this.$emit('update:date', val)
        }
      },
    },
  },
  watch: {
    date: {
      handler() {
        this.$forceUpdate()
      },
      deep: true,
    },
    hasTime: {
      handler(newVal) {
        if (newVal) {
          this.setCalendarToDateTimeFormat()
        } else {
          this.setCalendarToDateFormat()
        }
      },
      immediate: true,
    },
  },
  methods: {
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel
      this.setCalendarToDateTimeFormat()
    },
    setCalendarToDateTimeFormat() {
      this.dateType = 'datetime'
      this.formatType = 'DD/MM/YYYY HH:mm'
      this.$emit('update:hasTime', true)
      this.submitEventToAnalytics('Seleção de data com hora e minuto')
    },
    setCalendarToDateFormat() {
      this.dateType = 'date'
      this.formatType = 'DD/MM/YYYY'
      this.showTimePanel = false
      this.$emit('update:hasTime', false)
    },
    submitEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Calendário',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.xmx-btn.xmx-datepicker-btn-confirm {
  background: #7f1a54;
  color: white;
  margin-left: 2em;

  &:hover {
    background: #691043;
    color: white;
  }
}
</style>

<style lang="scss">
.xmx-datepicker-main {
  .xmx-time-item.active {
    background-color: #7f1a54 !important;
    color: white !important;
  }
}
</style>
